import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface PaywallModalProps {
  feature: string;
  onClose?: () => void;
}

const PaywallModal: React.FC<PaywallModalProps> = ({ feature, onClose }) => {
  const navigate = useNavigate();

  // Prevent body scroll while modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleUpgrade = () => {
    navigate('/upgrade');
    onClose?.();
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0,
        backgroundColor: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000,
        padding: '20px',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          backgroundColor: 'var(--color-surface)',
          borderRadius: 20,
          padding: '28px 24px',
          maxWidth: 340,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        }}
      >
        {/* Lock icon */}
        <div style={{
          width: 52, height: 52, borderRadius: '50%',
          backgroundColor: 'var(--color-success-light)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px',
          fontSize: 24,
        }}>
          🔒
        </div>

        <h2 style={{
          fontSize: 18, fontWeight: 800, color: 'var(--color-text)',
          margin: '0 0 8px',
        }}>
          Pro feature
        </h2>

        <p style={{
          fontSize: 14, color: 'var(--color-text-muted)',
          lineHeight: 1.5, margin: '0 0 24px',
        }}>
          <strong style={{ color: 'var(--color-text)' }}>{feature}</strong> is available on Phrenos Pro.
          Upgrade to unlock all words, unlimited sessions, and full cross-device sync.
        </p>

        <button
          onClick={handleUpgrade}
          style={{
            width: '100%', padding: '13px 0',
            backgroundColor: 'var(--color-button)', color: 'var(--color-button-text)',
            border: 'none', borderRadius: 12,
            fontSize: 15, fontWeight: 700,
            cursor: 'pointer', marginBottom: 10,
          }}
        >
          See Pro plans →
        </button>

        {onClose && (
          <button
            onClick={onClose}
            style={{
              width: '100%', padding: '10px 0',
              backgroundColor: 'transparent', color: 'var(--color-text-muted)',
              border: 'none', borderRadius: 12,
              fontSize: 14, cursor: 'pointer',
            }}
          >
            Maybe later
          </button>
        )}
      </div>
    </div>
  );
};

export default PaywallModal;
